// extracted by mini-css-extract-plugin
export default {"InfoContainer":"_InfoContainer--XUzYN","InfoBox":"_InfoBox--iKjXR","InfoValue":"_InfoValue--aNNpE","Divider":"_Divider--EJwfD","DividerWithMarginTop":"_DividerWithMarginTop--GYuMc"};